/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from '@angular/common/http';

import {Observable} from 'rxjs';


import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class ConfiguratorValidatorService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Valider l&#39;existence d&#39;un d&#39;une valeur de champ dans une collection
     * Cette requête permet de valider l&#39;existence d&#39;une valeur de champ dans une collection.&lt;br&gt;La requête prend en paramètre une base de données, une collection, un champ et une valeur de champ.&lt;br&gt;La requête retourne un booléen qui indique si la valeur de champ existe dans la collection donnée dans la base donnée.&lt;br&gt;&lt;b&gt;Attention : &lt;/b&gt; Il est important de noter que la valeur de champ est sensible à la casse.
     * @param collection collection
     * @param database database
     * @param field field
     * @param value value
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public isExistUsingPOST(collection: string, database: string, field: string, value: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public isExistUsingPOST(collection: string, database: string, field: string, value: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public isExistUsingPOST(collection: string, database: string, field: string, value: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public isExistUsingPOST(collection: string, database: string, field: string, value: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (collection === null || collection === undefined) {
            throw new Error('Required parameter collection was null or undefined when calling isExistUsingPOST.');
        }

        if (database === null || database === undefined) {
            throw new Error('Required parameter database was null or undefined when calling isExistUsingPOST.');
        }

        if (field === null || field === undefined) {
            throw new Error('Required parameter field was null or undefined when calling isExistUsingPOST.');
        }

        if (value === null || value === undefined) {
            throw new Error('Required parameter value was null or undefined when calling isExistUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<boolean>(`${this.basePath}/api/validator/${encodeURIComponent(String(database))}/${encodeURIComponent(String(collection))}/${encodeURIComponent(String(field))}`,
            value,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
